import { Link } from 'react-router-dom'
import Button from '../components/ui/Button'

export default function Home() {
  return (
    <div className="max-w-4xl mx-auto text-center space-y-8">
      <div className="space-y-4">
        <h1 className="text-5xl font-bold text-gray-900">
          MPCFillToPDF Web
        </h1>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg p-8 space-y-6">
        <h2 className="text-2xl font-semibold">How it works</h2>
        <div className="grid md:grid-cols-3 gap-6 text-left">
          <div className="space-y-2">
            <div className="text-3xl">📝</div>
            <h3 className="font-semibold">1. Add Cards</h3>
            <p className="text-gray-600 text-sm">
              Paste your decklist or search for cards individually
            </p>
          </div>
          <div className="space-y-2">
            <div className="text-3xl">⚙️</div>
            <h3 className="font-semibold">2. Configure</h3>
            <p className="text-gray-600 text-sm">
              Choose page size, layout, and print options
            </p>
          </div>
          <div className="space-y-2">
            <div className="text-3xl">📄</div>
            <h3 className="font-semibold">3. Download</h3>
            <p className="text-gray-600 text-sm">
              Get your print-ready PDF
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center gap-4">
        <Link to="/builder">
          <Button size="lg">Start Building</Button>
        </Link>
        <Link to="/local">
          <Button size="lg" variant="secondary">
            Upload Local Images
          </Button>
        </Link>
      </div>
    </div>
  )
}
